import { ReactNode, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { AccessibilityPanel, AccessibilityButton } from '@/components/base/AccessibilityPanel';
import { useAccessibility } from '@/hooks/useAccessibility';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const { isOpen: accessibilityOpen, setIsOpen: setAccessibilityOpen } = useAccessibility();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>
      <AccessibilityButton
        onClick={() => setAccessibilityOpen(!accessibilityOpen)}
        isOpen={accessibilityOpen}
      />
      <AccessibilityPanel
        isOpen={accessibilityOpen}
        onClose={() => setAccessibilityOpen(false)}
      />
    </div>
  );
}
